import { render } from "./SubscribeFreeHosting.vue?vue&type=template&id=01fc07b8&scoped=true"
import script from "./SubscribeFreeHosting.vue?vue&type=script&lang=js"
export * from "./SubscribeFreeHosting.vue?vue&type=script&lang=js"

import "./subscribe-free-hosting.scss?vue&type=style&index=0&id=01fc07b8&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fc07b8"]])

export default __exports__